import useWindowScrollPosition from './useWindowScrollPosition';
import ddt from '@wix/da-ddt';
import { useContext, useMemo } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
function getOffset(el) {
    if (!el || !el.current) {
        return { top: 0 };
    }
    return {
        top: el.current.offsetTop,
    };
}
/**
 * This is very specific hook that gives you a bounds object
 * you can use to calculate on/off screen rendering.
 *
 * It does not react to DOM changes, so if you alter the offset
 * by adding elements above the component being handled you will
 * need to make sure the offset gets recalculated.
 *
 * @param containerRef    Ref of the parent container
 * @param throttleMs      Throttle of scroll events
 * @param visiblePadding  Padding for bounds, roughly your row height
 * @param minRenderedPadding Minimum render padding size
 */
function useScreenBounds(containerRef, throttleMs, visiblePadding, enabled, minRenderedPadding) {
    if (enabled === void 0) { enabled = true; }
    var isMobile = useContext(MobileContext);
    var scrollY = useWindowScrollPosition(throttleMs, enabled).y;
    var renderedPaddingForDevice = isMobile
        ? minRenderedPadding === null || minRenderedPadding === void 0 ? void 0 : minRenderedPadding.mobile : minRenderedPadding === null || minRenderedPadding === void 0 ? void 0 : minRenderedPadding.desktop;
    var bounds = useMemo(function () {
        if (!enabled) {
            return undefined;
        }
        var top = getOffset(containerRef).top;
        var windowHeight = typeof window !== 'undefined' ? window.innerHeight : visiblePadding * 10;
        var renderedPadding = windowHeight * 5;
        if (renderedPaddingForDevice) {
            renderedPadding = Math.max(renderedPaddingForDevice, renderedPadding);
        }
        return {
            offsetTop: top,
            visibleTop: scrollY - visiblePadding,
            visibleBottom: scrollY + windowHeight + visiblePadding,
            renderedTop: scrollY - renderedPadding,
            renderedBottom: scrollY + windowHeight + renderedPadding,
            onscreenTop: scrollY,
            onscreenBottom: scrollY + windowHeight,
        };
    }, [
        containerRef,
        enabled,
        renderedPaddingForDevice,
        visiblePadding,
        scrollY,
    ]);
    enabled && ddt.log('hook.screenbounds', 'Bounds:', bounds);
    return bounds;
}
export default useScreenBounds;
//# sourceMappingURL=useScreenBounds.js.map